import {
  withTranslation,
} from 'react-i18next';

import ChampionshipSponsorFieldsView from './ChampionshipSponsorFieldsView';

const TranslatedComponent = withTranslation()(ChampionshipSponsorFieldsView);

const Component = TranslatedComponent;

export default Component;
